<template>
  <div class="contain">
    <p v-for="p in paragraphs" :key="p">{{ p }}</p>
    <CardActions>
      <Button @click="hideModal">{{ $t('arrow_match_button_continue') }}</Button>
    </CardActions>
  </div>
</template>

<script>
import { hideModal } from '@/store'
import { mapMutations } from 'vuex'
import { Button, CardActions } from '@neurotrack/web-shared-components'

export default {
  name: 'ArrowDirection',
  components: { Button, CardActions },
  methods: {
    ...mapMutations([hideModal])
  },
  props: {
    body: String,
    expected: String,
    answer: String,
    correct: Boolean
  },
  computed: {
    paragraphs() {
      const str = this.$i18n.t(
        `arrow_match_tutorial_feedback_body_${this.expected}_web`
      )
      return str.split('\n\n')
    }
  }
}
</script>

<style scoped>
p {
  text-align: center;
  margin-top: 0;
}
.contain {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
